import { Entity } from "typeorm";
import { CitationBlock } from "./citation-block.model";

@Entity()
export class CitationField {
    constructor (public block: CitationBlock, public value: string) {
    }
}
